import React from 'react';

import { Dropdown } from 'semantic-ui-react';

const JPDropdown = props => {
    const {
        className,
        classNames = [],
        placeholder,
        value,
        options,
        onChange,
        isEditable = true,
        isMultiple,
    } = props;

    return (
        <Dropdown
            fluid
            search
            selection
            className={className || classNames.join(' ')}
            placeholder={placeholder}
            value={value}
            multiple={isMultiple}
            disabled={!isEditable}
            options={options}
            onChange={onChange}
        />
    );
};

export default JPDropdown;
